/**
 * @module interface
 */
import type { V2TimImage } from './v2TimImage';

export interface V2TimImageElem {
    path?: string;
    imageList?: V2TimImage[];
}
